import { forwardRef } from 'react';

import { styled } from '@spazious/dollhouse-theme';

export interface LoaderBarProps extends React.HTMLAttributes<HTMLDivElement> {}

export const LoaderInner = styled(
  forwardRef(
    ({ children, ...restProps }: LoaderBarProps, ref: React.ForwardedRef<HTMLDivElement>) => (
      <div ref={ref}>
        <div {...restProps}>{children}</div>
      </div>
    )
  )
).withConfig({
  displayName: 'LoaderInner',
})`
  width: 100px;
  height: 3px;
  background: #272727;
  text-align: center;
`;

export default LoaderInner;
